export function breakStringIntoLines(
  originalString: string,
  lineLength: number,
) {
  const regex = new RegExp(`.{1,${lineLength}}`, "g")
  return originalString.match(regex) || []
}
